module.exports = __webpack_public_path__ + "static/media/selos-carbono-neutro-banner.f7e6799b.png";